'use client'

import { useTrackElementInteracted } from '@nwwp/segment-analytics'
import { cn } from '@nwwp/ui-shadcn'

function InstagramBadgeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.54667 19.9901C4.10064 19.9743 3.52579 19.9394 3.26451 19.8867C2.86567 19.8061 2.48902 19.684 2.17579 19.5244C1.80777 19.3368 1.47793 19.0975 1.19313 18.8131C0.90767 18.5282 0.667414 18.1981 0.479107 17.8295C0.319907 17.518 0.197861 17.1436 0.116977 16.747C0.0631801 16.4831 0.0276006 15.904 0.0114717 15.4551C0.00493113 15.2716 0.00157522 15.0342 0.00157522 14.9246L0 5.0769C0 4.96784 0.00332166 4.73032 0.00982801 4.54664C0.025683 4.10064 0.0605775 3.52579 0.113347 3.26451C0.193855 2.8657 0.316003 2.48902 0.475614 2.17579C0.663202 1.80774 0.902465 1.47797 1.18683 1.19313C1.47174 0.907704 1.80192 0.667449 2.17045 0.479107C2.48203 0.319941 2.85639 0.197861 3.25293 0.116977C3.51685 0.0631801 4.09602 0.0276006 4.54492 0.011506C4.72833 0.00493113 4.96582 0.00157522 5.07533 0.00157522L14.9231 0C15.0322 0 15.2697 0.00328742 15.4533 0.00982801C15.8993 0.0257172 16.4742 0.0605775 16.7355 0.113347C17.1343 0.193889 17.511 0.316037 17.8242 0.475614C18.1922 0.663202 18.522 0.902499 18.8068 1.18683C19.0923 1.47177 19.3325 1.80188 19.5209 2.17045C19.68 2.48203 19.8021 2.85636 19.883 3.25293C19.9368 3.51685 19.9724 4.09605 19.9885 4.54492C19.9951 4.72837 19.9984 4.96582 19.9984 5.07533L20 14.9231C20 15.0322 19.9967 15.2697 19.9901 15.4533C19.9742 15.8993 19.9394 16.4742 19.8866 16.7355C19.8061 17.1343 19.684 17.5109 19.5244 17.8242C19.3368 18.1922 19.0975 18.522 18.8132 18.8069C18.5282 19.0923 18.198 19.3326 17.8295 19.5209C17.5179 19.6801 17.1436 19.8021 16.747 19.883C16.4831 19.9368 15.9039 19.9724 15.4551 19.9885C15.2716 19.9951 15.0341 19.9984 14.9246 19.9984L5.0769 20C4.9678 20 4.73029 19.9967 4.54667 19.9901Z"
        fill="url(#ig-bg)"
      />
      <mask
        id="ig-mask"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.54667 19.9901C4.10064 19.9743 3.52579 19.9394 3.26451 19.8867C2.86567 19.8061 2.48902 19.684 2.17579 19.5244C1.80777 19.3368 1.47793 19.0975 1.19313 18.8131C0.90767 18.5282 0.667414 18.1981 0.479107 17.8295C0.319907 17.518 0.197861 17.1436 0.116977 16.747C0.0631801 16.4831 0.0276006 15.904 0.0114717 15.4551C0.00493113 15.2716 0.00157522 15.0342 0.00157522 14.9246L0 5.0769C0 4.96784 0.00332166 4.73032 0.00982801 4.54664C0.025683 4.10064 0.0605775 3.52579 0.113347 3.26451C0.193855 2.8657 0.316003 2.48902 0.475614 2.17579C0.663202 1.80774 0.902465 1.47797 1.18683 1.19313C1.47174 0.907704 1.80192 0.667449 2.17045 0.479107C2.48203 0.319941 2.85639 0.197861 3.25293 0.116977C3.51685 0.0631801 4.09602 0.0276006 4.54492 0.011506C4.72833 0.00493113 4.96582 0.00157522 5.07533 0.00157522L14.9231 0C15.0322 0 15.2697 0.00328742 15.4533 0.00982801C15.8993 0.0257172 16.4742 0.0605775 16.7355 0.113347C17.1343 0.193889 17.511 0.316037 17.8242 0.475614C18.1922 0.663202 18.522 0.902499 18.8068 1.18683C19.0923 1.47177 19.3325 1.80188 19.5209 2.17045C19.68 2.48203 19.8021 2.85636 19.883 3.25293C19.9368 3.51685 19.9724 4.09605 19.9885 4.54492C19.9951 4.72837 19.9984 4.96582 19.9984 5.07533L20 14.9231C20 15.0322 19.9967 15.2697 19.9901 15.4533C19.9742 15.8993 19.9394 16.4742 19.8866 16.7355C19.8061 17.1343 19.684 17.5109 19.5244 17.8242C19.3368 18.1922 19.0975 18.522 18.8132 18.8069C18.5282 19.0923 18.198 19.3326 17.8295 19.5209C17.5179 19.6801 17.1436 19.8021 16.747 19.883C16.4831 19.9368 15.9039 19.9724 15.4551 19.9885C15.2716 19.9951 15.0341 19.9984 14.9246 19.9984L5.0769 20C4.9678 20 4.73029 19.9967 4.54667 19.9901Z"
          fill="white"
        />
      </mask>
      <g mask="url(#ig-mask)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0412 2.57275C8.03206 2.57275 7.77991 2.58159 6.99078 2.6177C6.2032 2.65397 5.66561 2.77936 5.19521 2.96333C4.70864 3.15335 4.29589 3.40753 3.88468 3.8212C3.47316 4.23471 3.2206 4.64978 3.03082 5.13893C2.84741 5.61211 2.72257 6.15287 2.68712 6.94456C2.65183 7.73811 2.64258 7.99183 2.64258 10.0123C2.64258 12.0327 2.65152 12.2855 2.68727 13.0791C2.72349 13.8711 2.84818 14.4117 3.03098 14.8847C3.22009 15.374 3.47285 15.7891 3.88422 16.2026C4.29527 16.6164 4.70802 16.8712 5.19429 17.0612C5.66499 17.2452 6.20273 17.3706 6.99016 17.4069C7.77929 17.443 8.03128 17.4518 10.0403 17.4518C12.0497 17.4518 12.301 17.443 13.0902 17.4069C13.8777 17.3706 14.416 17.2452 14.8867 17.0612C15.3731 16.8712 15.7852 16.6164 16.1963 16.2026C16.6078 15.7891 16.8605 15.374 17.0501 14.8849C17.232 14.4117 17.3568 13.8709 17.3938 13.0792C17.4293 12.2857 17.4385 12.0327 17.4385 10.0123C17.4385 7.99183 17.4293 7.73827 17.3938 6.94472C17.3568 6.15272 17.232 5.61211 17.0501 5.13908C16.8605 4.64978 16.608 4.23471 16.1963 3.8212C15.7847 3.40738 15.3732 3.15319 14.8862 2.96333C14.4146 2.77936 13.8767 2.65397 13.0891 2.6177C12.3 2.58159 12.0487 2.57275 10.0389 2.57275H10.0412ZM9.79476 3.91339H9.79486L10.0414 3.91347C12.0167 3.91347 12.2508 3.92059 13.0309 3.95624C13.7522 3.98941 14.1437 4.11061 14.4044 4.21244C14.7497 4.34728 14.9958 4.50847 15.2546 4.76886C15.5135 5.02924 15.6738 5.27722 15.8082 5.6244C15.9095 5.88634 16.0302 6.28001 16.063 7.00537C16.0984 7.78962 16.1061 8.0252 16.1061 10.0106C16.1061 11.9961 16.0984 12.2316 16.063 13.0159C16.03 13.7412 15.9095 14.1349 15.8082 14.3969C15.6741 14.744 15.5135 14.9912 15.2546 15.2515C14.9957 15.5118 14.7498 15.673 14.4044 15.8079C14.144 15.9102 13.7522 16.0311 13.0309 16.0642C12.251 16.0999 12.0167 16.1076 10.0414 16.1076C8.066 16.1076 7.83189 16.0999 7.05201 16.0642C6.3307 16.0308 5.93922 15.9096 5.67828 15.8077C5.33304 15.6729 5.08644 15.5117 4.82751 15.2513C4.56858 14.9909 4.40829 14.7436 4.27389 14.3962C4.17263 14.1343 4.05195 13.7406 4.01912 13.0153C3.98367 12.231 3.97658 11.9954 3.97658 10.0088C3.97658 8.0221 3.98367 7.78776 4.01912 7.00351C4.0521 6.27815 4.17263 5.88448 4.27389 5.62223C4.40798 5.27505 4.56858 5.02707 4.82751 4.76669C5.08644 4.5063 5.33304 4.34511 5.67828 4.20996C5.93906 4.10767 6.3307 3.98678 7.05201 3.95345C7.73448 3.92245 7.99896 3.91316 9.37777 3.91161V3.91347C9.50655 3.91326 9.64507 3.91333 9.79455 3.91339H9.79466H9.79476ZM13.1027 6.0412C13.1027 5.54817 13.5004 5.14876 13.9905 5.14876V5.14845C14.4806 5.14845 14.8782 5.54833 14.8782 6.04125C14.8782 6.53412 14.4806 6.934 13.9905 6.934C13.5004 6.934 13.1027 6.53412 13.1027 6.0412ZM10.0413 6.19184C7.94321 6.19192 6.2422 7.90252 6.2422 10.0123C6.2422 12.1222 7.94329 13.8321 10.0414 13.8321C12.1395 13.8321 13.84 12.1222 13.84 10.0123C13.84 7.90247 12.1394 6.19184 10.0413 6.19184ZM12.5075 10.0123C12.5075 8.64268 11.4033 7.53249 10.0415 7.53249C8.67945 7.53249 7.57545 8.64268 7.57545 10.0123C7.57545 11.3819 8.67945 12.4922 10.0415 12.4922C11.4033 12.4922 12.5075 11.3819 12.5075 10.0123Z"
          fill="white"
        />
      </g>
      <defs>
        <radialGradient
          id="ig-bg"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.31253 21.5404) rotate(-90) scale(19.8214 19.8215)"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
      </defs>
    </svg>
  )
}

function TikTokBadgeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.54667 19.9901C4.10064 19.9743 3.52579 19.9394 3.26451 19.8867C2.86567 19.8061 2.48902 19.684 2.17579 19.5244C1.80777 19.3368 1.47793 19.0975 1.19313 18.8131C0.90767 18.5282 0.667414 18.1981 0.479107 17.8295C0.319907 17.518 0.197861 17.1436 0.116977 16.747C0.0631801 16.4831 0.0276006 15.904 0.0114717 15.4551C0.00493113 15.2716 0.00157522 15.0342 0.00157522 14.9246L0 5.0769C0 4.96784 0.00332166 4.73032 0.00982801 4.54664C0.025683 4.10064 0.0605775 3.52579 0.113347 3.26451C0.193855 2.8657 0.316003 2.48902 0.475614 2.17579C0.663202 1.80774 0.902465 1.47797 1.18683 1.19313C1.47174 0.907704 1.80192 0.667449 2.17045 0.479107C2.48203 0.319941 2.85639 0.197861 3.25293 0.116977C3.51685 0.0631801 4.09602 0.0276006 4.54492 0.011506C4.72833 0.00493113 4.96582 0.00157522 5.07533 0.00157522L14.9231 0C15.0322 0 15.2697 0.00328742 15.4533 0.00982801C15.8993 0.0257172 16.4742 0.0605775 16.7355 0.113347C17.1343 0.193889 17.511 0.316037 17.8242 0.475614C18.1922 0.663202 18.522 0.902499 18.8068 1.18683C19.0923 1.47177 19.3325 1.80188 19.5209 2.17045C19.68 2.48203 19.8021 2.85636 19.883 3.25293C19.9368 3.51685 19.9724 4.09605 19.9885 4.54492C19.9951 4.72837 19.9984 4.96582 19.9984 5.07533L20 14.9231C20 15.0322 19.9967 15.2697 19.9901 15.4533C19.9742 15.8993 19.9394 16.4742 19.8866 16.7355C19.8061 17.1343 19.684 17.5109 19.5244 17.8242C19.3368 18.1922 19.0975 18.522 18.8132 18.8069C18.5282 19.0923 18.198 19.3326 17.8295 19.5209C17.5179 19.6801 17.1436 19.8021 16.747 19.883C16.4831 19.9368 15.9039 19.9724 15.4551 19.9885C15.2716 19.9951 15.0341 19.9984 14.9246 19.9984L5.0769 20C4.9678 20 4.73029 19.9967 4.54667 19.9901Z"
        fill="#161722"
      />
      <path
        d="M8.28557 8.3705V7.75713C8.07279 7.72327 7.85783 7.7049 7.64239 7.70217C6.62816 7.69975 5.63969 8.02146 4.82117 8.62038C4.00265 9.21929 3.39691 10.0641 3.09231 11.0315C2.7877 11.9989 2.80017 13.0383 3.1279 13.9981C3.45562 14.958 4.08146 15.788 4.91411 16.3671C4.28801 15.6964 3.86937 14.8589 3.7087 13.9556C3.54803 13.0522 3.65221 12.1217 4.00865 11.2763C4.36509 10.4309 4.95858 9.70666 5.71748 9.19105C6.47639 8.67544 7.3683 8.39046 8.28557 8.3705Z"
        fill="#65D2E9"
      />
      <path
        d="M8.40134 15.2999C8.96153 15.2993 9.49987 15.0825 9.90428 14.6949C10.3087 14.3073 10.548 13.7786 10.5724 13.2189V2.84551H12.468C12.4294 2.6288 12.4108 2.40899 12.4125 2.18887H9.82045V12.5518C9.79958 13.1141 9.56176 13.6464 9.15686 14.0371C8.75197 14.4279 8.21149 14.6466 7.64881 14.6474C7.29948 14.6443 6.95584 14.5586 6.64603 14.3971C6.84679 14.6753 7.11044 14.902 7.41548 15.0589C7.72052 15.2158 8.05832 15.2984 8.40134 15.2999Z"
        fill="#65D2E9"
      />
      <path
        d="M16.0079 6.36486V5.78834C15.3104 5.78832 14.6284 5.58248 14.0473 5.1966C14.5565 5.78897 15.2447 6.19947 16.0079 6.36603V6.36486Z"
        fill="#65D2E9"
      />
      <path
        d="M14.0474 5.19665C13.4752 4.54481 13.1597 3.70703 13.1598 2.83966H12.4681C12.5575 3.31911 12.7436 3.77534 13.015 4.18056C13.2864 4.58577 13.6375 4.93149 14.0468 5.19665H14.0474Z"
        fill="#E6436D"
      />
      <path
        d="M7.64416 10.2959C7.15887 10.2986 6.6884 10.4634 6.30748 10.7641C5.92657 11.0648 5.65706 11.4842 5.54176 11.9556C5.42646 12.427 5.47199 12.9234 5.67111 13.3659C5.87024 13.8085 6.21153 14.1719 6.64079 14.3983C6.40603 14.074 6.26547 13.6911 6.23463 13.292C6.20379 12.8929 6.28388 12.493 6.46605 12.1365C6.64822 11.7801 6.92538 11.4809 7.26691 11.272C7.60844 11.0632 8.00104 10.9528 8.40136 10.9531C8.61945 10.9554 8.83606 10.9891 9.04455 11.0531V8.41545C8.83161 8.38362 8.61667 8.36701 8.40136 8.36575H8.28442V10.3713C8.07576 10.3154 7.8601 10.29 7.64416 10.2959Z"
        fill="#E6436D"
      />
      <path
        d="M16.0079 6.36486V8.37043C14.7164 8.36762 13.4585 7.95849 12.4125 7.201V12.471C12.4099 13.734 11.9063 14.9443 11.0124 15.8363C10.1184 16.7284 8.90706 17.2294 7.64414 17.2294C6.66735 17.2313 5.71406 16.93 4.91586 16.367C5.56673 17.0671 6.41336 17.555 7.34547 17.7671C8.27758 17.9792 9.25195 17.9057 10.1417 17.5561C11.0314 17.2065 11.7952 16.5971 12.3336 15.8072C12.8721 15.0173 13.1601 14.0836 13.1603 13.1277V7.87401C14.21 8.6265 15.4695 9.03006 16.761 9.02765V6.44496C16.5079 6.44441 16.2555 6.41756 16.0079 6.36486Z"
        fill="#E6436D"
      />
      <path
        d="M12.4125 12.4723V7.20222C13.4627 7.95526 14.7232 8.35867 16.0155 8.35528V6.34971C15.2525 6.1887 14.5626 5.78401 14.0497 5.19665C13.6404 4.93149 13.2893 4.58577 13.0179 4.18056C12.7465 3.77534 12.5604 3.31911 12.471 2.83966H10.5724V13.2195C10.5539 13.6713 10.3952 14.1061 10.1183 14.4636C9.84131 14.821 9.45992 15.0833 9.02706 15.214C8.59421 15.3447 8.13139 15.3374 7.7029 15.193C7.27441 15.0486 6.90154 14.7743 6.63609 14.4082C6.20671 14.1821 5.86524 13.8188 5.66598 13.3763C5.46671 12.9338 5.42108 12.4374 5.53633 11.9659C5.65159 11.4945 5.92112 11.0751 6.30208 10.7744C6.68304 10.4737 7.15357 10.309 7.63888 10.3065C7.857 10.3083 8.07369 10.3419 8.28207 10.4065V8.4003C7.35976 8.41599 6.46194 8.69967 5.69807 9.21677C4.93419 9.73386 4.33726 10.462 3.98005 11.3125C3.62285 12.163 3.52079 13.099 3.68633 14.0065C3.85187 14.9139 4.27786 15.7536 4.91235 16.4232C5.71819 16.9669 6.67224 17.2485 7.64414 17.2295C8.90687 17.2295 10.118 16.7286 11.012 15.8368C11.9059 14.945 12.4096 13.735 12.4125 12.4723Z"
        fill="white"
      />
    </svg>
  )
}

function PlayCircleIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="black" fillOpacity="0.45" />
      <circle cx="32" cy="32" r="31" stroke="white" strokeOpacity="0.3" strokeWidth="1" />
      <path d="M26 22L44 32L26 42V22Z" fill="white" />
    </svg>
  )
}

function ExternalLinkIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M6 3H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-3M9 2h5m0 0v5m0-5L8 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const PLATFORM_CONFIG = {
  instagram: { Icon: InstagramBadgeIcon, label: 'Instagram' },
  tiktok: { Icon: TikTokBadgeIcon, label: 'TikTok' },
} as const

export function SocialVideoCard({
  thumbnailUrl,
  href,
  platform,
  duration,
  handle,
  caption,
  avatarUrl,
  watchLabel,
}: {
  thumbnailUrl?: string
  href: string
  platform: 'instagram' | 'tiktok'
  duration?: string
  handle: string
  caption: string
  avatarUrl?: string
  watchLabel: string
}) {
  const trackElementInteracted = useTrackElementInteracted()
  const { Icon, label } = PLATFORM_CONFIG[platform]

  return (
    <div className={cn('w-full overflow-hidden rounded-[20px] border border-charcoal bg-gray-dark', 'shadow-xl')}>
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={watchLabel}
        className="relative block h-90 w-full overflow-hidden bg-neutral-surface"
        onClick={() => trackElementInteracted({ element: watchLabel, platform })}
      >
        {thumbnailUrl && (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={thumbnailUrl} alt={caption} className="absolute inset-0 size-full object-cover" />
        )}

        <div className="absolute inset-x-0 top-0 flex items-center justify-between p-4">
          <div className="flex items-center gap-2 rounded-full bg-black/60 py-1.5 pr-3 pl-2.5">
            <Icon />
            <span className="text-body-bold text-white tablet:text-body-bold-lg">{label}</span>
          </div>
          {duration && (
            <div className="rounded bg-black/60 px-2.5 py-1.5">
              <span className="text-body-bold text-white tablet:text-body-bold-lg">{duration}</span>
            </div>
          )}
        </div>

        <div className="absolute inset-0 flex items-center justify-center">
          <PlayCircleIcon />
        </div>
      </a>

      <div className="flex gap-4 bg-charcoal p-6">
        <div className="relative size-12 shrink-0 overflow-hidden rounded-full border border-white/15 bg-black">
          {avatarUrl ? (
            // eslint-disable-next-line @next/next/no-img-element
            <img src={avatarUrl} alt={handle} className="size-full object-cover" />
          ) : (
            <div className="flex size-full items-center justify-center bg-black text-body-sm-bold text-white italic">
              wp
            </div>
          )}
        </div>

        <div className="flex min-w-0 flex-col gap-3">
          <div className="flex flex-col gap-1.5">
            <p className="text-body-bold text-white tablet:text-body-bold-lg">{handle}</p>
            <p className="line-clamp-2 text-body-sm text-frost tablet:text-body">{caption}</p>
          </div>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-blue"
            onClick={() => trackElementInteracted({ element: watchLabel, platform })}
          >
            <span className="text-body-bold tablet:text-body-bold-lg">{watchLabel}</span>
            <ExternalLinkIcon />
          </a>
        </div>
      </div>
    </div>
  )
}
